// extracted by mini-css-extract-plugin
export default {"carousel":"Projects_carousel__R81rL","carouselControls":"Projects_carouselControls__6cXPJ","carouselIndicator":"Projects_carouselIndicator__yaCxf"};